export enum TipType {
  LIFE_PRO_TIP = 'LPT',
  YOU_SHOULD_KNOW = 'YSK',
  TODAY_I_LEARNED = 'TIL',
  DO_YOU_KNOW = 'DYK',
}
